import MolGrid, { Column } from "@moltech/molui/molgrid";
import { useEffect, useRef, useState } from "react";
import Buttons from "../../../../../../../components/ui/button/Buttons";
import { useGetContractAmendmentsAvailableScopesListMutation, useInsertAmendmentScopesMutation } from "../../../../../../../app/services/contractAPI";
import ToastService from "../../../../../../../services/toastService/ToastService";
import Checkbox from "../../../../../../../components/finalForms/ui/inputs/checkBox/CheckBox";
import PropTypes from "prop-types";

const AddAmendmentsScope = (props) => {
    const gridRef = useRef();
    const contractId = props.contractId;
    const [gridData, setGridData] = useState([]);
    const [selectedCheckboxRows, setSelectedCheckboxRows] = useState([]);

    const [getAllAmendmentScopeList, {
        isLoading: isAllAmendmentScopeLoding,
        isSuccess: isAllAmendmentScopeFetching,
        data: AllAmendmentScopeData
    }] = useGetContractAmendmentsAvailableScopesListMutation();

    const [addAmendmentScopeList, {
        // isLoading: addAmendmentScopeLoding,
        isSuccess: addAmendmentScopeFetching,
        data: addAmendmentScopeData
    }] = useInsertAmendmentScopesMutation();

    useEffect(() => {
        const request = {
            plContractAmendmentKey: props.amendmentRowData.plContractAmendmentKey,
            pbAdd: props.amendmentScopeRowData.addRemove
        }
        getAllAmendmentScopeList(request);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contractId]);

    useEffect(() => {
        if (!isAllAmendmentScopeLoding && isAllAmendmentScopeFetching && AllAmendmentScopeData) {
            setGridData(AllAmendmentScopeData);
        }
    }, [isAllAmendmentScopeLoding, isAllAmendmentScopeFetching, AllAmendmentScopeData])

    useEffect(() => {
        if (addAmendmentScopeFetching && addAmendmentScopeData) {
            if (addAmendmentScopeData) {
                ToastService.success(addAmendmentScopeData?.errorMessage);
            }
        }
    }, [addAmendmentScopeFetching, addAmendmentScopeData]);

    const handleSave = () => {
        if (selectedCheckboxRows && selectedCheckboxRows.length > 0) {
            const contractAmendmentKey = selectedCheckboxRows.map(row => row.plContractAmendmentKey).join(',');
            const lScopeKey = selectedCheckboxRows.map(row => row.lScopeKey).join(',');
            const cost = selectedCheckboxRows.map(row => row.nCost).join(',');


            // const request = {
            //     plContractAmendmentKey:contractAmendmentKey,
            //     plScopeKey:lScopeKey,
            //     pnCost:,
            //     pbAddToContract:,
            //     plContractScopeKey:,
            //     plScopeTypeKey:,
            //     plClientKey:,
            //     plDepartmentKey:,
            //     psSerialNumber:,
            // }
            // addAmendmentScopeList(request)
        } else {
            ToastService.error("Please select at least one amendment scope.");
        }
    }
    // const data = [{
    //     addRemove: "Add",
    //     dtChangeDate: "2025-11-12",
    //     sSerialNumber: "2106920",
    //     sScopeTypeDesc: "BRYAN SHEATH H2702",
    //     sClientName1: "Soin Medical Center - OH",
    //     sDepartmentName: "Endoscopy",
    //     nCost: "20.00"
    // },
    // {
    //     addRemove: "Add",
    //     dtChangeDate: "2025-11-12",
    //     sSerialNumber: "2106920",
    //     sScopeTypeDesc: "BRYAN SHEATH H2702",
    //     sClientName1: "Soin Medical Center - OH",
    //     sDepartmentName: "Endoscopy",
    //     nCost: "20.00"
    // }]
    return (
        <div className="row gap-4">
            <div className="scrollable-grid col-12 amendment-scope-checkbox">
                <MolGrid
                    ref={gridRef}
                    value={gridData}
                    grouping
                    expandableRowGroups={true}
                    paginator={false}
                    scrollable
                    scrollHeight="flex"
                    filterDisplay="row"
                    sortMode="single"
                    showGridlines
                    resizableColumns
                    selection={selectedCheckboxRows}
                    onSelectionChange={(e) => setSelectedCheckboxRows(e.value)}
                >
                    {/* <Column selectionMode="multiple" bodyStyle={{ textAlign: "center" }} /> */}
                    <Column field='amendmentScope'
                        bodyStyle={{ textAlign: "center" }}
                        body={((rowData, index) => {
                            return (
                                <Checkbox
                                    keyId={index + 1}
                                    name="selectedCheckboxRows"
                                    dataField={'selectedCheckboxRows'}
                                    //   onChange={() => handleRowSelection(rowData)}
                                    checked={selectedCheckboxRows.some(item => item.id === rowData.id)}
                                />
                            )
                        })}
                    />
                    <Column field="sSerialNumber" header="Serial#" grouping sortable />
                    <Column field="sScopeTypeDesc" header="Model" grouping sortable />
                    <Column field="sClientName1" header="Client" grouping sortable />
                    <Column field="sDepartmentName" header="Department" grouping sortable />
                    <Column field="nCost" header="Cost" grouping sortable />
                </MolGrid>
            </div>
            <div className="d-flex justify-content-end gap-3 mt-2">
                <Buttons
                    buttonText="Save"
                    onClick={handleSave}
                    buttonTypeClassName="btn blue-btn"
                    titleText=""
                    isLoading={isAllAmendmentScopeLoding}
                />
                <Buttons
                    buttonText="Cancel"cost
                    onClick={props.onClose}
                    buttonTypeClassName="btn dark-btn"
                    titleText="Cancel"
                />
            </div>
        </div>
    );
}
AddAmendmentsScope.propTypes = {
    contractId: PropTypes.number,
    amendmentRowData: PropTypes.object,
    amendmentScopeRowData: PropTypes.object,
    onClose: PropTypes.func,
};
export default AddAmendmentsScope;